export const GET_ACCESS_TOKEN_REQUEST = 'GET_ACCESS_TOKEN_REQUEST';
export const GET_ACCESS_TOKEN_REQUEST_ERROR = 'GET_ACCESS_TOKEN_REQUEST_ERROR';
export const GET_REFRESH_TOKEN_REQUEST_ERROR = 'GET_REFRESH_TOKEN_REQUEST_ERROR';
export const SET_TOKEN_INFO = 'SET_TOKEN_INFO';
export const SET_SERVER_COOKIES = 'SET_SERVER_COOKIES';
export const CLEAR_TOKEN_INFO = 'CLEAR_TOKEN_INFO';
